var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.9","d":"M1.13672 8.10156H14.1367M8.13672 1.10156L15.1367 8.10156L8.13672 15.1016","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Arrow.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
